import {EventEmitter} from 'events';

const AppNotificationsEventOpened = new EventEmitter();

export default AppNotificationsEventOpened;
